import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import EmptyRouterView from './EmptyRouterView'
// Public views
import Home from '@/views/public/Home'
import Contact from '@/views/public/Contact'
import Pricing from '@/views/public/Pricing'
import About from '@/views/public/About'
import NotFound from '@/views/public/NotFound' 
import Privacy from '@/views/public/Privacy'
import Login from '@/views/public/Login'

// Common views
import Logout from '@/views/common/Logout'

// Lecturer views
import Welcome from '@/views/lecturer/Welcome'
import LecturerDashboard from '@/views/lecturer/LecturerDashboard'
import TeachingSession from '@/views/lecturer/TeachingSession'
import Content from '@/views/lecturer/content/Index'
import Schedule from '@/views/lecturer/Schedule'

// Student views
import Invite from '@/views/student/Invite'
import StudentDashboard from '@/views/student/StudentDashboard'
import Attempt from '@/views/student/Attempt'

// Admin views
import Users from '@/views/admin/Users'
import Messages from '@/views/admin/Messages'

Vue.use(VueRouter)

const routes = [

  {
    path: '*', 
    component: NotFound
  },
  {
    path: '/',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
        beforeEnter: (to, from, next) => {
          if (store.getters.user.loggedIn){
            if (store.getters.user.data.userType == 'LECTURER'){
              next({ name: 'LecturerDashboard' })
            }
            else if (store.getters.user.data.userType == 'STUDENT'){
              next({ name: 'StudentDashboard' })
            }
          }
          else {
            next()
          }
        }
      },
      { path: 'about', name: 'About', component: About },
      { path: 'contact', name: 'Contact', component: Contact },
      { path: 'pricing', name: 'Pricing', component: Pricing },
      { path: 'privacy', name: 'Privacy', component: Privacy },
      { path: 'login/:userType', name: 'Login', component: Login},
      { path: 'logout', name: 'Logout', component: Logout}
    ]
  },
  {
    path: '/lecturer',
    component: EmptyRouterView,
    beforeEnter: (to, from, next) => {
      if (store.getters.user.loggedIn && store.getters.user.data.userType == 'LECTURER'){
        // Bind Firebase references to Vuex for this lecturer
        store.dispatch('bindLecturerData')
        next()
      }
      else {
        next({ name: 'Home'})
      }
    },
    children: [
      { path: 'welcome', name: 'Welcome', component: Welcome},
      { path: 'dashboard', name: 'LecturerDashboard', component: LecturerDashboard},
      { path: 'content', name: 'Content', component: Content},
      { path: 'schedule', name: 'Schedule', component: Schedule},
      { path: 'session/:id', name: 'TeachingSession', component: TeachingSession}
    ]
  },
  {
    path: '/student',
    component: EmptyRouterView,
    children: [
      { path: 'invite/:id', name: 'Invite', component: Invite},
      { 
        path: 'dashboard',
        beforeEnter: (to, from, next) => {
          if (store.getters.user.loggedIn && store.getters.user.data.userType == 'STUDENT'){
            // Bind Firebase references to Vuex for this lecturer
            store.dispatch('bindStudentData')
            next()
          }
          else {
            next({ name: 'Home'})
          }
        },
        name: 'StudentDashboard',
        component: StudentDashboard
      },
      { 
        path: 'attempt/:id',
        beforeEnter: (to, from, next) => {
          if (store.getters.user.loggedIn && store.getters.user.data.userType=='STUDENT'){
            // Bind Firebase references to Vuex for this lecturer
            store.dispatch('bindStudentData')
            next()
          }
          else {
            next({ name: 'Home'})
          }
        },
        name: 'Attempt',
        component: Attempt
      }
    ]
  },
  {
    path: '/admin',
    component: EmptyRouterView,
    beforeEnter: (to, from, next) => {
      if (store.getters.user.loggedIn && store.getters.user.isAdmin){
        next()
      }
      else {
        next({ name: 'Home'})
      }
    },
    children: [
      { path: 'users', name: 'Users', component: Users},
      { path: 'messages', name: 'Messages', component: Messages}
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Create a global route guard to create binding for user data
router.beforeEach(async (to, from, next) => {
  if (store.getters.user.loggedIn) {
    // Bind Firebase references to Vuex for this user
    await store.dispatch('bindUserData')
  }
  next()
})
export default router
